import { RelodeApiError } from "@relode/core";

import { CombinedClientPublicCandidateActionTypes } from "..";
import { converters } from "../../../../../shared/backend";
import { candidatesPublic } from "../../../../../shared/backend/controllers";
import { ClientPublicCandidateState } from "../clientPublicCandidateState";
import { creators } from "./clientPublicCandidateActionTypes";

export const useClientPublicCandidateActions = (
    state: ClientPublicCandidateState,
    dispatch: React.Dispatch<CombinedClientPublicCandidateActionTypes>
) => {
    const loadCandidate = async (token: string) => {
        try {
            dispatch(creators.loadCandidate());
            const detailsResponse =
                await candidatesPublic.candidatePublicService.getCandidatePublicDetails(
                    token
                );
            const details =
                converters.convertLeadJobDetailPublicResponse(detailsResponse);
            dispatch(creators.loadCandidateSuccess(details));
        } catch (err) {
            if (err instanceof RelodeApiError) {
                dispatch(creators.loadCandidateFailure(err));
            } else {
                throw err;
            }
        }
    };

    return {
        loadCandidate,
    };
};

export type CandidateActions = ReturnType<
    typeof useClientPublicCandidateActions
>;
